import { useCallback, useEffect, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useGetESignatureCaseTypes = () => {
  const [caseTypesByCategory, setCaseTypesByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCaseTypes = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await api_without_cancellation.get(
        "/api/firmsetting-page/casetype-by-category/"
      );
      const categories = data?.data ?? {};

      setCaseTypesByCategory(categories);
      return categories;
    } catch (requestError) {
      setError(requestError);
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCaseTypes().catch(() => {});
  }, [fetchCaseTypes]);

  return { caseTypesByCategory, loading, error, refetch: fetchCaseTypes };
};

export default useGetESignatureCaseTypes;
